import { Button, Tooltip } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import styles from './DeleteButton.module.css';

const DeleteButton = ({
  buttonText = 'Delete',
  onDeleteItem = () => {},
  miniVersion = false,
  useXIcon = false,
  useBanIcon = false,
  tooltipText = 'Delete',
  className = '',
}) => {
  return (
    <Tooltip
      minimal
      className={styles.fullwidth}
      content={tooltipText}
      placement={'auto'}
      shouldReturnFocusOnClose={false}>
      <Button
        small={miniVersion}
        minimal={miniVersion}
        fill={!miniVersion}
        intent='danger'
        icon={useXIcon ? 'delete' : useBanIcon ? 'ban-circle' : 'trash'}
        onClick={onDeleteItem}
        className={className}>
        {!miniVersion && buttonText}
      </Button>
    </Tooltip>
  );
};

DeleteButton.propTypes = {
  buttonText: PropTypes.string,
  onDeleteItem: PropTypes.func,
  miniVersion: PropTypes.bool,
  useXIcon: PropTypes.bool,
  useBanIcon: PropTypes.bool,
  tooltipText: PropTypes.string,
  className: PropTypes.string,
};

export default DeleteButton;
